import { server as serverCore } from 'src/core/environments/server';
import { ServerConfig } from "src/index";
export const server: ServerConfig = {
    ...serverCore,
}